import { CheckCircle2, Circle, Loader2, XCircle } from 'lucide-react';
import type { BrandKitProgress } from './types';

/** The package job's 12-step progress rail (2s poll while packaging). */
export default function KitProgress({ progress }: { progress: BrandKitProgress }) {
  if (!progress.steps) return null;
  return (
    <div className="space-y-1.5">
      {progress.steps.map((step) => (
        <div key={step.step} className="flex items-center gap-2 text-sm">
          {step.status === 'done' ? (
            <CheckCircle2 className="h-4 w-4 shrink-0 text-sage-600" aria-hidden="true" />
          ) : step.status === 'running' ? (
            <Loader2 className="h-4 w-4 shrink-0 animate-spin text-sage-600" aria-hidden="true" />
          ) : step.status === 'failed' ? (
            <XCircle className="h-4 w-4 shrink-0 text-red-500" aria-hidden="true" />
          ) : (
            <Circle className="h-4 w-4 shrink-0 text-ink-muted/40" aria-hidden="true" />
          )}
          <span
            className={
              step.status === 'failed'
                ? 'text-red-600'
                : step.status === 'pending'
                  ? 'text-ink-muted'
                  : 'text-ink'
            }
          >
            {step.message}
          </span>
        </div>
      ))}
      {progress.lastError && (
        <p className="pt-1 text-xs text-red-500">{progress.lastError}</p>
      )}
    </div>
  );
}
